import { AxiosResponse } from 'axios';

import { SFCCBasket } from '../../models/sfcc-basket';
import { SFCCSharedBasket } from '../../models/sfcc-shared-basket';
import { addLocaleToBasketUrl } from '../../utilities/add-locale-to-basket-url';
import { sfccHttp, sfccSettings } from '../basket-api';

export const createSharedBasket = async (basket: SFCCBasket): Promise<string> => {
  const sharedBasket: SFCCSharedBasket = {
    product_items: basket.product_items,
    coupon_items: basket.coupon_items,
  };

  const url = '/SharedBasket-Create';
  const finalUrl = addLocaleToBasketUrl(url, sfccSettings.shopApiLocale);
  const response = await sfccHttp.post<
    SFCCSharedBasket,
    AxiosResponse<{ customObjectKey: string }>
  >(finalUrl, sharedBasket);

  return response.data?.customObjectKey;
};
